module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1036-065355a684243cf0be1e47167c6263f2.png";